var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material';
const StyledSpan = styled('span')(({ theme }) => {
    return Object.assign(Object.assign({ cursor: 'text', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }, theme.typography.body1), { fontSize: '14px', color: '#0E1621' });
});
const Span = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return _jsx(StyledSpan, Object.assign({}, props, { children: children }));
};
export default Span;
